export const TextStyle = {
  color: 'text.primary',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 700,
  fontSize: 12,
  letterSpacing: 0.15,
}

export const TextStyle2 = {
  color: '#BDBDBF',
  fontFamily: 'Roboto',
  fontStyle: 'normal',
  fontWeight: 400,
  fontSize: 10,
  letterSpacing: 0.15,
}

export const TextStyle3 = {
  '& .MuiOutlinedInput-input ': {
    fontFamily: 'Roboto',
    fontStyle: 'normal',
    fontWeight: 400,
    fontSize: 16,
    lineHeight: 24,
    letterSpacing: 0.15,
  },
}

export const BoxStyle = {
  flexDirection: 'row',
  justifyContent: 'center',
  alignItems: 'center',
}

export const ColumnBoxStyle = {
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
}

export const BoxStyle1 = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  // marginTop: '-12px',
}

export const TextStyle4 = {
  fontSize: '16px',
  lineHeight: '24px',
  fontFamily: 'Roboto',
  fontWeight: '400',
  letterSpacing: '0.15px',
  color: '#1F4266',
}
